<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <div class="container-box">
        <div class="text-center">
        <img v-if="studentProfileAuthorize == ''" width="100px" height="100px" src="../assets/img/icon/icondefault.svg" @click="GoDashboard()"/>
         <img v-else width="100px" height="100px" :src="photoURL" style="border-radius:50%;border:5px solid #fff" @click="GoDashboard()">
        <br />
        <br />
        <h3 class="title mt-4">Hello {{ user.name }}!</h3>
      </div>
       
      </div>
    </CContainer>
  
  </div>
</template>


<script>
export default {
  name: "Login",
  e1: "#app",
  data: function () {
    return {
      user: {},
      studentProfileAuthorize: "",
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
     GoDashboard() {
    this.$router.push("ExistingUser");
    },
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetUserProfile(this.user.id);
            this.GetAuthorizeProfile(this.user.id);
           
          }
        });
    },
      GetUserProfile() {
      this.$API
        .get(this.$ParentProfile + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfile = response.data;
          }
        });
    },
     GetAuthorizeProfile() {
      this.$API
        .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfileAuthorize = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.studentProfileAuthorize;
          }
        });
    },
  },
};
</script>


<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
  font-family: "Montserrat", sans-serif;
}
.container-box {
  max-width: 335px;
  margin: 0 auto;
}
</style>